<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates23">
<p class="centerImage"><img alt="images" id="plate23" src="images/plate23.jpg"/></p>
<p class="caption">They look at our Spitfires. Left to right: G/C A L Walters, Dr Evatt, S/Ldr Ray Thorold-Smith (OC 452 Squadron), RWF, Mr Drakeford, S/Ldr Ken James (OC 457 September).</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates23.vue?340ab07e